/**
 * Pack Bundle Builder - Whimsy Weaves Bedsheets
 * Section: sections/bundle-builder.liquid
 *
 * MIX MODE:
 *   - Har product card ka size toggle INDEPENDENT hai
 *   - User ek hi bundle mein Flat + Fitted mix kar sakta hai
 *   - Single group: Single Flat + Single Fitted (same price)
 *   - King group:   King Flat   + King Fitted   (same price)
 *   - URL: ?type=single  ya  ?type=king
 *
 * IMAGE SCROLL:
 *   - Har card mein multiple images horizontally scroll hote hain
 *   - Dots indicator current image highlight karta hai
 *
 * INFINITE SCROLL:
 *   - Button visible rahega (collection-tabs jaisa)
 *   - User scroll kare to auto-load trigger hoga
 *   - Manual click bhi kaam karega
 */
(function () {
  'use strict';

  // ============================================================
  // HIDDEN BUNDLE PRODUCTS (per group)
  // ============================================================
  var HIDDEN_PRODUCTS = {
    single_flat:   { 1: 44067277504575, 2: 44067278979135, 3: 44067280584767, 5: 44067280781375 },
    single_fitted: { 1: 44067277504575, 2: 44067278979135, 3: 44067280584767, 5: 44067280781375 },
    king_flat:     { 1: 44067282223167, 2: 44067379478591, 3: 44067283304511, 5: 44067286646847 },
    king_fitted:   { 1: 44067282223167, 2: 44067379478591, 3: 44067283304511, 5: 44067286646847 }
  };

  // ============================================================
  // DISPLAY PRICES (group-based)
  // ============================================================
  var DISPLAY_PRICES = {
    single_flat:   { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
    single_fitted: { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
    king_flat:     { 1: 1600, 2: 2900, 3: 4200, 5: 6800 },
    king_fitted:   { 1: 1600, 2: 2900, 3: 4200, 5: 6800 }
  };

  // ============================================================
  // PER-SHEET PRICE (save calculate karne ke liye)
  // ============================================================
  var PER_SHEET_PRICE = {
    single_flat:   1500,
    single_fitted: 1500,
    king_flat:     2000,
    king_fitted:   2000
  };

  var SIZE_LABELS = {
    single_flat:   'Single Flat',
    single_fitted: 'Single Fitted',
    king_flat:     'King Flat',
    king_fitted:   'King Fitted'
  };

  var VARIANT_LABELS = { flat: 'Flat', fitted: 'Fitted' };
  var GROUP_LABELS   = { single: 'Single', king: 'King' };

  // ============================================================

  function init() {
    var root = document.querySelector('[data-bb]');
    if (!root || root.__bbReady) return;
    root.__bbReady = true;

    var handle = root.getAttribute('data-collection') || 'all';
    var KEY = 'bb:' + handle;
    var DONE = 'bb:done:' + handle;

    var grid = root.querySelector('[data-bb-grid]');
    var subEl = root.querySelector('[data-bb-sub]');
    var slotsEl = root.querySelector('[data-bb-slots]');
    var msgEl = root.querySelector('[data-bb-msg]');
    var totalEl = root.querySelector('[data-bb-total]');
    var ctaEl = root.querySelector('[data-bb-cta]');
    var progEl = root.querySelector('[data-bb-progress]');
    var toastEl = root.querySelector('[data-bb-toast]');
    var loadWrap = root.querySelector('[data-bb-loadwrap]');
    var loadBtn = root.querySelector('[data-bb-loadmore]');
    var searchEl = root.querySelector('[data-bb-search]');
    var emptyEl = root.querySelector('[data-bb-empty]');
    var fixedAmountEl = root.querySelector('[data-bb-fixed-amount]');
    var fixedNoteEl = root.querySelector('[data-bb-fixed-note]');

    var pickedEl = root.querySelector('[data-bb-picked]');
    var targetEl = root.querySelector('[data-bb-target]');
    var saveTextEl = root.querySelector('[data-bb-save-text]');
    var groupLabelEl = root.querySelector('[data-bb-group-label]');
    var groupBadgeEl = root.querySelector('[data-bb-group-badge]');
    var ctaMainEl = root.querySelector('[data-bb-cta-main]');
    var ctaSubEl = root.querySelector('[data-bb-cta-sub]');
    var headerSelect = root.querySelector('[data-bb-size-select]');

    var packs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-pack]')).map(function (el) {
      return {
        el: el,
        qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
        priceEl: el.querySelector('[data-bb-pack-price]'),
        eachEl: el.querySelector('[data-bb-pack-each]'),
        afterEl: el.querySelector('[data-bb-pack-after]')
      };
    });
    if (!packs.length) return;
    packs.sort(function (a, b) { return a.qty - b.qty; });

    var state = {
      group: 'king',
      defaultSize: 'king_flat',
      qty: packs[0].qty,
      slots: []
    };

    var busy = false;
    var query = '';
    var loading = false;
    var failed = false;
    var nextPage = grid ? parseInt(grid.getAttribute('data-next-page'), 10) || 0 : 0;
    var totalPages = grid ? parseInt(grid.getAttribute('data-pages'), 10) || 1 : 1;
    var totalItems = grid ? parseInt(grid.getAttribute('data-total'), 10) || 0 : 0;
    var toastTimer = null;
    var searchTimer = null;
    var checkoutTimeout = null;
    var io = null; // IntersectionObserver

    /* ---------- helpers ---------- */
    function money(amount) {
      var n = Number(amount);
      if (isNaN(n)) n = 0;
      var parts = n.toFixed(2).split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return 'Rs. ' + intPart + '.' + parts[1];
    }
    function moneyShort(amount) {
      var n = Number(amount);
      if (isNaN(n)) n = 0;
      var intPart = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return 'Rs. ' + intPart;
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function packOf(qty) {
      for (var i = 0; i < packs.length; i++) if (packs[i].qty === qty) return packs[i];
      return null;
    }
    function displayPrice() {
      var table = DISPLAY_PRICES[state.defaultSize] || DISPLAY_PRICES.single_flat;
      return table[state.qty] || 0;
    }
    function perSheetPrice() {
      return PER_SHEET_PRICE[state.defaultSize] || 0;
    }
    function originalPrice() { return perSheetPrice() * state.qty; }
    function hiddenProductId() {
      var table = HIDDEN_PRODUCTS[state.defaultSize];
      if (!table) return null;
      return table[state.qty] || null;
    }
    function groupOf(sizeKey) {
      return (sizeKey || '').indexOf('single') === 0 ? 'single' : 'king';
    }
    function variantOf(sizeKey) {
      return (sizeKey || '').indexOf('fitted') > -1 ? 'fitted' : 'flat';
    }
    function composeSizeKey(group, variant) { return group + '_' + variant; }
    function cards() { return root.querySelectorAll('[data-bb-card]'); }

    function toast(text) {
      if (!toastEl) return;
      toastEl.textContent = text;
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
    }

    /* ---------- storage ---------- */
    function save() {
      try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }
    function load() {
      try {
        var raw = sessionStorage.getItem(KEY);
        if (!raw) return;
        var s = JSON.parse(raw);
        if (s && packOf(s.qty) && Array.isArray(s.slots)) {
          if (s.group === 'single' || s.group === 'king') state.group = s.group;
          if (s.defaultSize && DISPLAY_PRICES[s.defaultSize]) state.defaultSize = s.defaultSize;
          state.qty = s.qty;
          state.slots = s.slots.slice(0, s.qty);
        }
      } catch (e) {}
    }
    function consumeDone() {
      var was = false;
      try {
        was = sessionStorage.getItem(DONE) === '1';
        if (was) { sessionStorage.removeItem(DONE); sessionStorage.removeItem(KEY); }
      } catch (e) {}
      return was;
    }

    /* ---------- URL params ---------- */
    function readUrlParams() {
      try {
        var params = new URLSearchParams(window.location.search);
        var t = (params.get('type') || '').toLowerCase();
        if (t === 'single' || t === 'king') {
          state.group = t;
        }
        var sz = params.get('size');
        if (sz && DISPLAY_PRICES[sz] && groupOf(sz) === state.group) {
          state.defaultSize = sz;
        } else {
          state.defaultSize = composeSizeKey(state.group, variantOf(state.defaultSize));
        }
        var pk = params.get('pack');
        if (pk) {
          var pq = parseInt(pk, 10);
          if (packOf(pq)) state.qty = pq;
        }
      } catch (e) {}
    }

    function updateGroupBadge() {
      var group = state.group;
      if (groupLabelEl) groupLabelEl.textContent = GROUP_LABELS[group] || '';
      if (groupBadgeEl) {
        var other = group === 'single' ? 'king' : 'single';
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('type', other);
          u.searchParams.delete('pack');
          groupBadgeEl.setAttribute('href', u.pathname + '?' + u.searchParams.toString());
          groupBadgeEl.setAttribute('title', 'Switch to ' + GROUP_LABELS[other]);
        } catch (e) {
          groupBadgeEl.setAttribute('href', window.location.pathname + '?type=' + other);
        }
      }
    }

    function updateUrl() {
      try {
        var params = new URLSearchParams(window.location.search);
        params.set('type', state.group);
        params.set('pack', state.qty);
        var newUrl = window.location.pathname + '?' + params.toString();
        window.history.replaceState({}, '', newUrl);
      } catch (e) {}
    }

    /* ---------- card data ---------- */
    function cardData(card) {
      if (card.__bb) return card.__bb;
      var d = { title: '', vendor: '', img: '', variants: [] };
      var j = card.querySelector('[data-bb-json]');
      try { d = JSON.parse(j.textContent); } catch (e) {}
      d.pid = card.getAttribute('data-pid');
      card.__bb = d;
      return d;
    }
    function findVariantBySize(card, sizeKey) {
      var d = cardData(card);
      for (var i = 0; i < d.variants.length; i++) {
        var v = d.variants[i];
        if (v.sizeKey === sizeKey && v.available) return v;
      }
      return null;
    }
    function cardHasSize(card, sizeKey) {
      return !!findVariantBySize(card, sizeKey);
    }
    function cardHasAnyInGroup(card, group) {
      var d = cardData(card);
      var flatKey   = composeSizeKey(group, 'flat');
      var fittedKey = composeSizeKey(group, 'fitted');
      for (var i = 0; i < d.variants.length; i++) {
        var v = d.variants[i];
        if ((v.sizeKey === flatKey || v.sizeKey === fittedKey) && v.available) return true;
      }
      return false;
    }

    /* ---------- card size toggle ---------- */
    function getCardVariant(card) {
      var activeBtn = card.querySelector('[data-bb-card-size-btn].is-active');
      return activeBtn ? activeBtn.getAttribute('data-variant') : 'flat';
    }

    /* ---------- Media scroll (dots + smart touch swipe) ---------- */
    function initMediaScroll() {
      Array.prototype.forEach.call(root.querySelectorAll('[data-bb-media]'), function (media) {
        if (media.__bbMediaReady) return;
        media.__bbMediaReady = true;

        var track = media.querySelector('[data-bb-media-track]');
        var dots = media.querySelectorAll('[data-bb-dot]');
        if (!track) return;

        // ---------- Touch handling ----------
        var startX = 0;
        var startY = 0;
        var currentX = 0;
        var startScrollLeft = 0;
        var isDragging = false;
        var lockedDirection = null; // 'h' | 'v' | null

        track.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          currentX = startX;
          startScrollLeft = track.scrollLeft;
          isDragging = true;
          lockedDirection = null;
        }, { passive: true });

        track.addEventListener('touchmove', function (e) {
          if (!isDragging || e.touches.length !== 1) return;
          var x = e.touches[0].clientX;
          var y = e.touches[0].clientY;
          var dx = x - startX;
          var dy = y - startY;

          // Direction lock (first 6px)
          if (!lockedDirection) {
            if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
              lockedDirection = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
            } else {
              return;
            }
          }

          if (lockedDirection === 'h') {
            e.preventDefault();
            track.scrollLeft = startScrollLeft - dx;
            currentX = x;
          }
        }, { passive: false });

        track.addEventListener('touchend', function () {
          if (!isDragging) return;
          isDragging = false;

          if (lockedDirection === 'h') {
            var slide = track.firstElementChild;
            if (slide) {
              var slideWidth = slide.offsetWidth || 1;
              var totalDx = currentX - startX;
              var moved = -totalDx;
              var threshold = Math.max(50, slideWidth * 0.25);
              if (Math.abs(moved) > threshold) {
                var dir = moved > 0 ? 1 : -1;
                var targetIdx = Math.round((startScrollLeft + dir * slideWidth) / slideWidth);
                var maxIdx = track.children.length - 1;
                if (targetIdx < 0) targetIdx = 0;
                if (targetIdx > maxIdx) targetIdx = maxIdx;
                track.scrollTo({ left: targetIdx * slideWidth, behavior: 'smooth' });
              } else {
                var currentIdx = Math.round(startScrollLeft / slideWidth);
                track.scrollTo({ left: currentIdx * slideWidth, behavior: 'smooth' });
              }
            }
          }
          lockedDirection = null;
        }, { passive: true });

        // ---------- Dots update ----------
        var updateDots = function () {
          if (!dots.length) return;
          var slide = track.firstElementChild;
          if (!slide) return;
          var slideWidth = slide.offsetWidth || 1;
          var idx = Math.round(track.scrollLeft / slideWidth);
          if (idx < 0) idx = 0;
          if (idx > dots.length - 1) idx = dots.length - 1;
          Array.prototype.forEach.call(dots, function (dot, i) {
            dot.classList.toggle('is-active', i === idx);
          });
        };

        var scrollTimer = null;
        track.addEventListener('scroll', function () {
          if (scrollTimer) clearTimeout(scrollTimer);
          scrollTimer = setTimeout(updateDots, 40);
        }, { passive: true });

        updateDots();
      });
    }

    /* ---------- Infinite scroll (auto-load) ---------- */
    function hasMore() {
      var loaded = cards().length;
      var left = Math.max(totalItems - loaded, 0);
      return nextPage > 0 && nextPage <= totalPages && left > 0;
    }

    function initInfiniteScroll() {
      if (!loadBtn) return;

      // Purana observer disconnect
      if (io) {
        io.disconnect();
        io = null;
      }

      // IntersectionObserver support check
      if (!('IntersectionObserver' in window)) return;

      io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        if (loading || failed) return;
        if (!hasMore()) return;

        loadMore().then(function () {
          // Naye cards load hone ke baad dobara observe karein
          if (hasMore() && io) {
            io.unobserve(loadBtn);
            io.observe(loadBtn);
          }
        });
      }, { rootMargin: '400px 0px' });

      io.observe(loadBtn);
    }

    /* ---------- actions ---------- */
    function addFromCard(card) {
      if (state.slots.length >= state.qty) {
        toast('Your pack is full. Remove an item or choose a bigger pack.');
        return;
      }
      var d = cardData(card);
      var variant = getCardVariant(card);
      var sizeKey = composeSizeKey(state.group, variant);
      var v = findVariantBySize(card, sizeKey);
      if (!v) {
        toast('This size is not available for this product.');
        return;
      }
      state.slots.push({
        pid: d.pid,
        vid: v.id,
        title: d.title,
        vendor: d.vendor,
        img: d.img || '',
        size: v.title || '',
        sizeKey: v.sizeKey || sizeKey,
        price: v.price || 0
      });
      save();
      render();
    }

    function removeLastOf(pid) {
      for (var i = state.slots.length - 1; i >= 0; i--) {
        if (String(state.slots[i].pid) === String(pid)) { state.slots.splice(i, 1); break; }
      }
      save();
      render();
    }
    function removeAt(idx) {
      if (idx < 0 || idx >= state.slots.length) return;
      state.slots.splice(idx, 1);
      save();
      render();
    }
    function setPack(qty) {
      if (!packOf(qty)) return;
      var trimmed = state.slots.length > qty;
      state.qty = qty;
      if (trimmed) state.slots = state.slots.slice(0, qty);
      save();
      updateUrl();
      render();
      if (trimmed) toast('Extra items were removed from your pack.');
    }
    function setDefaultVariant(variant) {
      if (variant !== 'flat' && variant !== 'fitted') return;
      state.defaultSize = composeSizeKey(state.group, variant);
      save();
      render();
    }

    /* ---------- CHECKOUT ---------- */
    function checkout() {
      if (busy) return;
      if (state.slots.length !== state.qty) {
        toast('Please complete your pack first.');
        return;
      }
      var hiddenId = hiddenProductId();
      if (!hiddenId) {
        toast('This bundle is not available. Please try another pack.');
        return;
      }
      busy = true;
      render();
      clearTimeout(checkoutTimeout);
      checkoutTimeout = setTimeout(function () {
        if (busy) { busy = false; render(); toast('Request timed out. Please refresh and try again.'); }
      }, 15000);

      var itemsList = state.slots.map(function (s) {
        return s.title + (s.size ? ' (' + s.size + ')' : '');
      }).join(' | ');

      var props = {
        _bundle_size: String(state.qty),
        _bundle_group: state.group,
        _bundle_size_type: state.defaultSize,
        _bundle_items: itemsList
      };
      props['Bundle'] = GROUP_LABELS[state.group] + ' × Pack of ' + state.qty;
      state.slots.forEach(function (s, i) {
        props['Bedsheet ' + (i + 1)] = s.title + (s.size ? ' (' + s.size + ')' : '');
      });

      var items = [{ id: hiddenId, quantity: 1, properties: props }];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.text().then(function (text) {
            var data;
            try { data = JSON.parse(text); } catch (e) { data = { raw: text }; }
            if (!res.ok) {
              var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status + ': ' + (data.raw || 'Unknown error'));
              throw new Error(msg);
            }
            return data;
          });
        })
        .then(function () {
          clearTimeout(checkoutTimeout);
          try { sessionStorage.setItem(DONE, '1'); } catch (e) {}
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          clearTimeout(checkoutTimeout);
          busy = false;
          render();
          toast(err.message || 'Something went wrong. Please try again.');
        });
    }

    /* ---------- render ---------- */
    function render() {
      if (headerSelect) headerSelect.value = variantOf(state.defaultSize);

      updateGroupBadge();

      // Packs
      packs.forEach(function (p) {
        var on = p.qty === state.qty;
        p.el.classList.toggle('is-active', on);
        p.el.setAttribute('aria-pressed', on ? 'true' : 'false');
        var table = DISPLAY_PRICES[state.defaultSize] || DISPLAY_PRICES.single_flat;
        var display = table[p.qty] || 0;
        var per = perSheetPrice();
        var original = per * p.qty;
        var saveAmt = Math.max(original - display, 0);
        if (p.priceEl) p.priceEl.textContent = moneyShort(display);
        if (p.eachEl) {
          if (p.qty > 1 && display > 0) {
            p.eachEl.textContent = moneyShort(Math.round(display / p.qty)) + ' each';
            p.eachEl.hidden = false;
          } else { p.eachEl.textContent = ''; p.eachEl.hidden = true; }
        }
        if (p.afterEl) {
          if (saveAmt > 0) { p.afterEl.textContent = 'Save ' + moneyShort(saveAmt); p.afterEl.hidden = false; }
          else { p.afterEl.hidden = true; }
        }
      });

      // Fixed price / note
      var display = displayPrice();
      if (fixedAmountEl) fixedAmountEl.textContent = money(display);
      if (fixedNoteEl) fixedNoteEl.textContent = GROUP_LABELS[state.group] + ' × Pack of ' + state.qty;

      // Slots
      var n = state.slots.length;
      var left = state.qty - n;
      var full = left <= 0;

      var html = '';
      for (var i = 0; i < state.qty; i++) {
        if (i < n) {
          var s = state.slots[i];
          var label = s.title + (s.size ? ' (' + s.size + ')' : '');
          html += '<div class="bb-slot is-filled" title="' + esc(label) + '">' +
            (s.img ? '<img src="' + esc(s.img) + '" alt="' + esc(s.title) + '">' : '') +
            (s.size ? '<span class="bb-slot-size">' + esc(s.size) + '</span>' : '') +
            '<button type="button" class="bb-x" data-bb-remove="' + i + '" aria-label="Remove ' + esc(s.title) + '">&times;</button>' +
            '</div>';
        } else {
          html += '<div class="bb-slot"><span>' + (i + 1) + '</span></div>';
        }
      }
      if (slotsEl) slotsEl.innerHTML = html;

      if (msgEl) msgEl.textContent = full ? 'Your bundle is ready!' : 'Add ' + left + ' more to complete your bundle.';
      if (totalEl) totalEl.textContent = money(display);
      if (progEl) progEl.style.width = Math.round(n / state.qty * 100) + '%';
      if (pickedEl) pickedEl.textContent = n;
      if (targetEl) targetEl.textContent = state.qty;
      if (ctaMainEl) ctaMainEl.textContent = busy ? 'Please wait...' : (full ? 'Checkout' : 'Add ' + left + ' more');
      if (ctaSubEl) ctaSubEl.textContent = moneyShort(display) + ' total';
      if (ctaEl) ctaEl.disabled = !full || busy;
      root.classList.toggle('is-full', full);

      // Save text
      if (saveTextEl) {
        var orig = originalPrice();
        var saveAmt = Math.max(orig - display, 0);
        var savePct = orig > 0 ? ((saveAmt / orig) * 100) : 0;
        var pctText = (Math.round(savePct * 10) / 10);
        if (saveAmt > 0) {
          saveTextEl.textContent = 'You save ' + moneyShort(saveAmt) + ' (' + pctText + '%)';
          saveTextEl.hidden = false;
        } else { saveTextEl.textContent = ''; saveTextEl.hidden = true; }
      }

      // Cards
      var counts = {};
      state.slots.forEach(function (s) { counts[s.pid] = (counts[s.pid] || 0) + 1; });
      var fullCards = state.slots.length >= state.qty;

      Array.prototype.forEach.call(cards(), function (card) {
        var c = counts[card.getAttribute('data-pid')] || 0;
        var add = card.querySelector('[data-bb-add]');
        var step = card.querySelector('[data-bb-step]');
        var num = card.querySelector('[data-bb-qtyn]');
        var badge = card.querySelector('[data-bb-count]');

        var hasAny = cardHasAnyInGroup(card, state.group);
        card.hidden = !hasAny;
        card.classList.toggle('is-picked', c > 0);

        if (add) { add.hidden = c > 0; add.disabled = fullCards; }
        if (step) {
          step.hidden = c === 0;
          var inc = step.querySelector('[data-bb-inc]');
          if (inc) inc.disabled = fullCards;
        }
        if (num) num.textContent = c;
        if (badge) { badge.hidden = c === 0; badge.textContent = '×' + c; }
      });
    }

    /* ---------- load more + search ---------- */
    function updateLoadUi() {
      var loaded = cards().length;
      var left = Math.max(totalItems - loaded, 0);
      var more = nextPage > 0 && nextPage <= totalPages && left > 0;
      if (loadWrap) loadWrap.hidden = !more;
      if (loadBtn) {
        loadBtn.disabled = loading;
        loadBtn.textContent = loading ? 'Loading...' : 'Load more' + (left ? ' (' + left + ' more)' : '');
      }
    }

    function loadMore() {
      if (loading || failed || !grid || !nextPage || nextPage > totalPages) return Promise.resolve();
      loading = true;
      updateLoadUi();
      var url = new URL(window.location.href);
      url.searchParams.set('page', nextPage);
      url.searchParams.set('view', 'pb-bundle');
      return fetch(url.toString(), { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('Could not load more products.'); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var found = doc.querySelectorAll('[data-bb-grid] > [data-bb-card]');
          Array.prototype.forEach.call(found, function (c) { grid.appendChild(document.importNode(c, true)); });
          nextPage += 1;
          if (!found.length) nextPage = 0;
        })
        .catch(function () { failed = true; toast('Could not load more products. Please refresh.'); })
        .then(function () {
          loading = false;
          updateLoadUi();
          render();
          applySearch();
          initMediaScroll();
          // Observer re-attach (naye cards ke baad)
          if (hasMore() && io) {
            io.unobserve(loadBtn);
            io.observe(loadBtn);
          }
        });
    }

    function loadAll() {
      return loadMore().then(function () {
        if (!failed && nextPage > 0 && nextPage <= totalPages) return loadAll();
      });
    }
    function applySearch() {
      var any = false;
      Array.prototype.forEach.call(cards(), function (card) {
        if (card.hidden && !card.classList.contains('is-picked')) return;
        var hit = !query || (card.getAttribute('data-search') || '').indexOf(query) > -1;
        card.hidden = !hit;
        if (hit) any = true;
      });
      if (emptyEl) emptyEl.hidden = any || !cards().length;
    }

    /* ---------- events ---------- */
    root.addEventListener('click', function (e) {
      var pill = e.target.closest('[data-bb-card-size-btn]');
      if (pill && root.contains(pill)) {
        var pillCard = pill.closest('[data-bb-card]');
        if (pillCard) {
          var siblings = pillCard.querySelectorAll('[data-bb-card-size-btn]');
          Array.prototype.forEach.call(siblings, function (btn) {
            var on = btn === pill;
            btn.classList.toggle('is-active', on);
            btn.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          return;
        }
      }

      var t = e.target.closest('[data-bb-pack],[data-bb-add],[data-bb-inc],[data-bb-dec],[data-bb-remove],[data-bb-cta],[data-bb-loadmore]');
      if (!t || !root.contains(t)) return;

      if (t.hasAttribute('data-bb-pack')) { setPack(parseInt(t.getAttribute('data-qty'), 10)); return; }
      if (t.hasAttribute('data-bb-remove')) { removeAt(parseInt(t.getAttribute('data-bb-remove'), 10)); return; }
      if (t.hasAttribute('data-bb-cta')) { checkout(); return; }
      if (t.hasAttribute('data-bb-loadmore')) { loadMore(); return; }

      var card = t.closest('[data-bb-card]');
      if (!card) return;
      if (t.hasAttribute('data-bb-add') || t.hasAttribute('data-bb-inc')) addFromCard(card);
      else if (t.hasAttribute('data-bb-dec')) removeLastOf(card.getAttribute('data-pid'));
    });

    root.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      if (t.hasAttribute && t.hasAttribute('data-bb-size-select')) {
        setDefaultVariant(t.value);
        return;
      }
    });

    if (searchEl) {
      searchEl.addEventListener('input', function () {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(function () {
          query = searchEl.value.trim().toLowerCase();
          applySearch();
          if (query && nextPage > 0 && nextPage <= totalPages) loadAll();
        }, 200);
      });
    }

    window.addEventListener('pageshow', function () {
      busy = false;
      clearTimeout(checkoutTimeout);
      if (consumeDone()) state.slots = [];
      render();
    });

    /* ---------- start ---------- */
    if (!consumeDone()) load();
    readUrlParams();
    render();
    updateUrl();
    updateLoadUi();
    initMediaScroll();
    initInfiniteScroll();   // ← Auto-load start
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();




// Without Auto Scroll
// /**
//  * Pack Bundle Builder - Whimsy Weaves Bedsheets
//  * Section: sections/bundle-builder.liquid
//  *
//  * MIX MODE:
//  *   - Har product card ka size toggle INDEPENDENT hai
//  *   - User ek hi bundle mein Flat + Fitted mix kar sakta hai
//  *   - Single group: Single Flat + Single Fitted (same price)
//  *   - King group:   King Flat   + King Fitted   (same price)
//  *   - URL: ?type=single  ya  ?type=king
//  *
//  * IMAGE SCROLL:
//  *   - Har card mein multiple images horizontally scroll hote hain
//  *   - Dots indicator current image highlight karta hai
//  */
// (function () {
//   'use strict';

//   // ============================================================
//   // HIDDEN BUNDLE PRODUCTS (per group)
//   // ============================================================
//   var HIDDEN_PRODUCTS = {
//     single_flat:   { 1: 44067277504575, 2: 44067278979135, 3: 44067280584767, 5: 44067280781375 },
//     single_fitted: { 1: 44067277504575, 2: 44067278979135, 3: 44067280584767, 5: 44067280781375 },
//     king_flat:     { 1: 44067282223167, 2: 44067379478591, 3: 44067283304511, 5: 44067286646847 },
//     king_fitted:   { 1: 44067282223167, 2: 44067379478591, 3: 44067283304511, 5: 44067286646847 }
//   };

//   // ============================================================
//   // DISPLAY PRICES (group-based)
//   // ============================================================
//   var DISPLAY_PRICES = {
//     single_flat:   { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
//     single_fitted: { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
//     king_flat:     { 1: 1600, 2: 2900, 3: 4200, 5: 6800 },
//     king_fitted:   { 1: 1600, 2: 2900, 3: 4200, 5: 6800 }
//   };

//   // ============================================================
//   // PER-SHEET PRICE (save calculate karne ke liye)
//   // ============================================================
//   var PER_SHEET_PRICE = {
//     single_flat:   1500,
//     single_fitted: 1500,
//     king_flat:     2000,
//     king_fitted:   2000
//   };

//   var SIZE_LABELS = {
//     single_flat:   'Single Flat',
//     single_fitted: 'Single Fitted',
//     king_flat:     'King Flat',
//     king_fitted:   'King Fitted'
//   };

//   var VARIANT_LABELS = { flat: 'Flat', fitted: 'Fitted' };
//   var GROUP_LABELS   = { single: 'Single', king: 'King' };

//   // ============================================================

//   function init() {
//     var root = document.querySelector('[data-bb]');
//     if (!root || root.__bbReady) return;
//     root.__bbReady = true;

//     var handle = root.getAttribute('data-collection') || 'all';
//     var KEY = 'bb:' + handle;
//     var DONE = 'bb:done:' + handle;

//     var grid = root.querySelector('[data-bb-grid]');
//     var subEl = root.querySelector('[data-bb-sub]');
//     var slotsEl = root.querySelector('[data-bb-slots]');
//     var msgEl = root.querySelector('[data-bb-msg]');
//     var totalEl = root.querySelector('[data-bb-total]');
//     var ctaEl = root.querySelector('[data-bb-cta]');
//     var progEl = root.querySelector('[data-bb-progress]');
//     var toastEl = root.querySelector('[data-bb-toast]');
//     var loadWrap = root.querySelector('[data-bb-loadwrap]');
//     var loadBtn = root.querySelector('[data-bb-loadmore]');
//     var searchEl = root.querySelector('[data-bb-search]');
//     var emptyEl = root.querySelector('[data-bb-empty]');
//     var fixedAmountEl = root.querySelector('[data-bb-fixed-amount]');
//     var fixedNoteEl = root.querySelector('[data-bb-fixed-note]');

//     var pickedEl = root.querySelector('[data-bb-picked]');
//     var targetEl = root.querySelector('[data-bb-target]');
//     var saveTextEl = root.querySelector('[data-bb-save-text]');
//     var groupLabelEl = root.querySelector('[data-bb-group-label]');
//     var groupBadgeEl = root.querySelector('[data-bb-group-badge]');
//     var ctaMainEl = root.querySelector('[data-bb-cta-main]');
//     var ctaSubEl = root.querySelector('[data-bb-cta-sub]');
//     var headerSelect = root.querySelector('[data-bb-size-select]');

//     var packs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-pack]')).map(function (el) {
//       return {
//         el: el,
//         qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
//         priceEl: el.querySelector('[data-bb-pack-price]'),
//         eachEl: el.querySelector('[data-bb-pack-each]'),
//         afterEl: el.querySelector('[data-bb-pack-after]')
//       };
//     });
//     if (!packs.length) return;
//     packs.sort(function (a, b) { return a.qty - b.qty; });

//     // State:
//     //   group       = 'single' | 'king'    (URL se)
//     //   defaultSize = jo default variant ka sizeKey ho, pack badge ke liye
//     //   slots       = [{ pid, vid, title, vendor, img, size, sizeKey, price }]
//     var state = {
//       group: 'king',
//       defaultSize: 'king_flat',
//       qty: packs[0].qty,
//       slots: []
//     };

//     var busy = false;
//     var query = '';
//     var loading = false;
//     var failed = false;
//     var nextPage = grid ? parseInt(grid.getAttribute('data-next-page'), 10) || 0 : 0;
//     var totalPages = grid ? parseInt(grid.getAttribute('data-pages'), 10) || 1 : 1;
//     var totalItems = grid ? parseInt(grid.getAttribute('data-total'), 10) || 0 : 0;
//     var toastTimer = null;
//     var searchTimer = null;
//     var checkoutTimeout = null;

//     /* ---------- helpers ---------- */
//     function money(amount) {
//       var n = Number(amount);
//       if (isNaN(n)) n = 0;
//       var parts = n.toFixed(2).split('.');
//       var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//       return 'Rs. ' + intPart + '.' + parts[1];
//     }
//     function moneyShort(amount) {
//       var n = Number(amount);
//       if (isNaN(n)) n = 0;
//       var intPart = String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//       return 'Rs. ' + intPart;
//     }
//     function esc(s) {
//       return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
//         return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
//       });
//     }
//     function packOf(qty) {
//       for (var i = 0; i < packs.length; i++) if (packs[i].qty === qty) return packs[i];
//       return null;
//     }
//     function displayPrice() {
//       var table = DISPLAY_PRICES[state.defaultSize] || DISPLAY_PRICES.single_flat;
//       return table[state.qty] || 0;
//     }
//     function perSheetPrice() {
//       return PER_SHEET_PRICE[state.defaultSize] || 0;
//     }
//     function originalPrice() { return perSheetPrice() * state.qty; }
//     function hiddenProductId() {
//       var table = HIDDEN_PRODUCTS[state.defaultSize];
//       if (!table) return null;
//       return table[state.qty] || null;
//     }
//     function groupOf(sizeKey) {
//       return (sizeKey || '').indexOf('single') === 0 ? 'single' : 'king';
//     }
//     function variantOf(sizeKey) {
//       return (sizeKey || '').indexOf('fitted') > -1 ? 'fitted' : 'flat';
//     }
//     function composeSizeKey(group, variant) { return group + '_' + variant; }
//     function cards() { return root.querySelectorAll('[data-bb-card]'); }

//     function toast(text) {
//       if (!toastEl) return;
//       toastEl.textContent = text;
//       toastEl.classList.add('is-on');
//       clearTimeout(toastTimer);
//       toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
//     }

//     /* ---------- storage ---------- */
//     function save() {
//       try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
//     }
//     function load() {
//       try {
//         var raw = sessionStorage.getItem(KEY);
//         if (!raw) return;
//         var s = JSON.parse(raw);
//         if (s && packOf(s.qty) && Array.isArray(s.slots)) {
//           if (s.group === 'single' || s.group === 'king') state.group = s.group;
//           if (s.defaultSize && DISPLAY_PRICES[s.defaultSize]) state.defaultSize = s.defaultSize;
//           state.qty = s.qty;
//           state.slots = s.slots.slice(0, s.qty);
//         }
//       } catch (e) {}
//     }
//     function consumeDone() {
//       var was = false;
//       try {
//         was = sessionStorage.getItem(DONE) === '1';
//         if (was) { sessionStorage.removeItem(DONE); sessionStorage.removeItem(KEY); }
//       } catch (e) {}
//       return was;
//     }

//     /* ---------- URL params ---------- */
//     function readUrlParams() {
//       try {
//         var params = new URLSearchParams(window.location.search);
//         var t = (params.get('type') || '').toLowerCase();
//         if (t === 'single' || t === 'king') {
//           state.group = t;
//         }
//         var sz = params.get('size');
//         if (sz && DISPLAY_PRICES[sz] && groupOf(sz) === state.group) {
//           state.defaultSize = sz;
//         } else {
//           state.defaultSize = composeSizeKey(state.group, variantOf(state.defaultSize));
//         }
//         var pk = params.get('pack');
//         if (pk) {
//           var pq = parseInt(pk, 10);
//           if (packOf(pq)) state.qty = pq;
//         }
//       } catch (e) {}
//     }

//     function updateGroupBadge() {
//       var group = state.group;
//       if (groupLabelEl) groupLabelEl.textContent = GROUP_LABELS[group] || '';
//       if (groupBadgeEl) {
//         var other = group === 'single' ? 'king' : 'single';
//         try {
//           var u = new URL(window.location.href);
//           u.searchParams.set('type', other);
//           u.searchParams.delete('pack');
//           groupBadgeEl.setAttribute('href', u.pathname + '?' + u.searchParams.toString());
//           groupBadgeEl.setAttribute('title', 'Switch to ' + GROUP_LABELS[other]);
//         } catch (e) {
//           groupBadgeEl.setAttribute('href', window.location.pathname + '?type=' + other);
//         }
//       }
//     }

//     function updateUrl() {
//       try {
//         var params = new URLSearchParams(window.location.search);
//         params.set('type', state.group);
//         params.set('pack', state.qty);
//         var newUrl = window.location.pathname + '?' + params.toString();
//         window.history.replaceState({}, '', newUrl);
//       } catch (e) {}
//     }

//     /* ---------- card data ---------- */
//     function cardData(card) {
//       if (card.__bb) return card.__bb;
//       var d = { title: '', vendor: '', img: '', variants: [] };
//       var j = card.querySelector('[data-bb-json]');
//       try { d = JSON.parse(j.textContent); } catch (e) {}
//       d.pid = card.getAttribute('data-pid');
//       card.__bb = d;
//       return d;
//     }
//     function findVariantBySize(card, sizeKey) {
//       var d = cardData(card);
//       for (var i = 0; i < d.variants.length; i++) {
//         var v = d.variants[i];
//         if (v.sizeKey === sizeKey && v.available) return v;
//       }
//       return null;
//     }
//     function cardHasSize(card, sizeKey) {
//       return !!findVariantBySize(card, sizeKey);
//     }
//     function cardHasAnyInGroup(card, group) {
//       var d = cardData(card);
//       var flatKey   = composeSizeKey(group, 'flat');
//       var fittedKey = composeSizeKey(group, 'fitted');
//       for (var i = 0; i < d.variants.length; i++) {
//         var v = d.variants[i];
//         if ((v.sizeKey === flatKey || v.sizeKey === fittedKey) && v.available) return true;
//       }
//       return false;
//     }

//     /* ---------- card size toggle ---------- */
//     // Card ka current variant padhein (pill button se)
//     function getCardVariant(card) {
//       var activeBtn = card.querySelector('[data-bb-card-size-btn].is-active');
//       return activeBtn ? activeBtn.getAttribute('data-variant') : 'flat';
//     }

//     /* ---------- Media scroll (dots update) ---------- */
//     // function initMediaScroll() {
//     //   Array.prototype.forEach.call(root.querySelectorAll('[data-bb-media]'), function (media) {
//     //     if (media.__bbMediaReady) return;
//     //     media.__bbMediaReady = true;

//     //     var track = media.querySelector('[data-bb-media-track]');
//     //     var dots = media.querySelectorAll('[data-bb-dot]');
//     //     if (!track) return;

//     //     var updateDots = function () {
//     //       if (!dots.length) return;
//     //       var slide = track.firstElementChild;
//     //       if (!slide) return;
//     //       var slideWidth = slide.offsetWidth || 1;
//     //       var idx = Math.round(track.scrollLeft / slideWidth);
//     //       if (idx < 0) idx = 0;
//     //       if (idx > dots.length - 1) idx = dots.length - 1;
//     //       Array.prototype.forEach.call(dots, function (dot, i) {
//     //         dot.classList.toggle('is-active', i === idx);
//     //       });
//     //     };

//     //     var scrollTimer = null;
//     //     track.addEventListener('scroll', function () {
//     //       if (scrollTimer) clearTimeout(scrollTimer);
//     //       scrollTimer = setTimeout(updateDots, 40);
//     //     }, { passive: true });

//     //     updateDots();
//     //   });
//     // }

//     /* ---------- Media scroll (dots + smart touch swipe) ---------- */
// function initMediaScroll() {
//   Array.prototype.forEach.call(root.querySelectorAll('[data-bb-media]'), function (media) {
//     if (media.__bbMediaReady) return;
//     media.__bbMediaReady = true;

//     var track = media.querySelector('[data-bb-media-track]');
//     var dots = media.querySelectorAll('[data-bb-dot]');
//     if (!track) return;

//     // ---------- Touch handling ----------
//     var startX = 0;
//     var startY = 0;
//     var currentX = 0;
//     var startScrollLeft = 0;
//     var isDragging = false;
//     var lockedDirection = null; // 'h' | 'v' | null

//     track.addEventListener('touchstart', function (e) {
//       if (e.touches.length !== 1) return;
//       startX = e.touches[0].clientX;
//       startY = e.touches[0].clientY;
//       currentX = startX;
//       startScrollLeft = track.scrollLeft;
//       isDragging = true;
//       lockedDirection = null;
//     }, { passive: true });

//     // track.addEventListener('touchmove', function (e) {
//     //   if (!isDragging || e.touches.length !== 1) return;
//     //   var x = e.touches[0].clientX;
//     //   var y = e.touches[0].clientY;
//     //   var dx = x - startX;
//     //   var dy = y - startY;

//     //   // Determine direction once (first 6px)
//     //   if (!lockedDirection) {
//     //     if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
//     //       lockedDirection = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
//     //     } else {
//     //       return; // wait for clear direction
//     //     }
//     //   }

//     //   if (lockedDirection === 'h') {
//     //     // Horizontal swipe — scroll the track, block page scroll
//     //     e.preventDefault();
//     //     track.scrollLeft = startScrollLeft - dx;
//     //     currentX = x;
//     //   }
//     //   // If 'v' — do nothing, let page scroll naturally
//     // }, { passive: false });

//     track.addEventListener('touchmove', function (e) {
//   if (!isDragging || e.touches.length !== 1) return;
//   var x = e.touches[0].clientX;
//   var y = e.touches[0].clientY;
//   var dx = x - startX;
//   var dy = y - startY;

//   // Direction lock (first 6px)
//   if (!lockedDirection) {
//     if (Math.abs(dx) > 6 || Math.abs(dy) > 6) {
//       lockedDirection = Math.abs(dx) > Math.abs(dy) ? 'h' : 'v';
//     } else {
//       return; // wait for direction
//     }
//   }

//   if (lockedDirection === 'h') {
//     // Horizontal: image scroll
//     e.preventDefault();
//     track.scrollLeft = startScrollLeft - dx;
//     currentX = x;
//   }
//   // Vertical: kuch nahi karein — page khud scroll hoga
// }, { passive: false });






//     track.addEventListener('touchend', function () {
//       if (!isDragging) return;
//       isDragging = false;

//       if (lockedDirection === 'h') {
//         // Snap to nearest slide
//         var slide = track.firstElementChild;
//         if (slide) {
//           var slideWidth = slide.offsetWidth || 1;
//           var totalDx = currentX - startX;
//           var moved = -totalDx;
//           // Threshold: 50px ya 25% slide width
//           var threshold = Math.max(50, slideWidth * 0.25);
//           if (Math.abs(moved) > threshold) {
//             var dir = moved > 0 ? 1 : -1;
//             var targetIdx = Math.round((startScrollLeft + dir * slideWidth) / slideWidth);
//             var maxIdx = track.children.length - 1;
//             if (targetIdx < 0) targetIdx = 0;
//             if (targetIdx > maxIdx) targetIdx = maxIdx;
//             track.scrollTo({ left: targetIdx * slideWidth, behavior: 'smooth' });
//           } else {
//             // Snap back to current slide
//             var currentIdx = Math.round(startScrollLeft / slideWidth);
//             track.scrollTo({ left: currentIdx * slideWidth, behavior: 'smooth' });
//           }
//         }
//       }
//       lockedDirection = null;
//     }, { passive: true });

//     // ---------- Dots update ----------
//     var updateDots = function () {
//       if (!dots.length) return;
//       var slide = track.firstElementChild;
//       if (!slide) return;
//       var slideWidth = slide.offsetWidth || 1;
//       var idx = Math.round(track.scrollLeft / slideWidth);
//       if (idx < 0) idx = 0;
//       if (idx > dots.length - 1) idx = dots.length - 1;
//       Array.prototype.forEach.call(dots, function (dot, i) {
//         dot.classList.toggle('is-active', i === idx);
//       });
//     };

//     var scrollTimer = null;
//     track.addEventListener('scroll', function () {
//       if (scrollTimer) clearTimeout(scrollTimer);
//       scrollTimer = setTimeout(updateDots, 40);
//     }, { passive: true });

//     updateDots();
//   });
// }



//     /* ---------- actions ---------- */
//     function addFromCard(card) {
//       if (state.slots.length >= state.qty) {
//         toast('Your pack is full. Remove an item or choose a bigger pack.');
//         return;
//       }
//       var d = cardData(card);
//       var variant = getCardVariant(card);
//       var sizeKey = composeSizeKey(state.group, variant);
//       var v = findVariantBySize(card, sizeKey);
//       if (!v) {
//         toast('This size is not available for this product.');
//         return;
//       }
//       state.slots.push({
//         pid: d.pid,
//         vid: v.id,
//         title: d.title,
//         vendor: d.vendor,
//         img: d.img || '',
//         size: v.title || '',
//         sizeKey: v.sizeKey || sizeKey,
//         price: v.price || 0
//       });
//       save();
//       render();
//     }

//     function removeLastOf(pid) {
//       for (var i = state.slots.length - 1; i >= 0; i--) {
//         if (String(state.slots[i].pid) === String(pid)) { state.slots.splice(i, 1); break; }
//       }
//       save();
//       render();
//     }
//     function removeAt(idx) {
//       if (idx < 0 || idx >= state.slots.length) return;
//       state.slots.splice(idx, 1);
//       save();
//       render();
//     }
//     function setPack(qty) {
//       if (!packOf(qty)) return;
//       var trimmed = state.slots.length > qty;
//       state.qty = qty;
//       if (trimmed) state.slots = state.slots.slice(0, qty);
//       save();
//       updateUrl();
//       render();
//       if (trimmed) toast('Extra items were removed from your pack.');
//     }
//     function setDefaultVariant(variant) {
//       if (variant !== 'flat' && variant !== 'fitted') return;
//       state.defaultSize = composeSizeKey(state.group, variant);
//       save();
//       render();
//     }

//     /* ---------- CHECKOUT ---------- */
//     function checkout() {
//       if (busy) return;
//       if (state.slots.length !== state.qty) {
//         toast('Please complete your pack first.');
//         return;
//       }
//       var hiddenId = hiddenProductId();
//       if (!hiddenId) {
//         toast('This bundle is not available. Please try another pack.');
//         return;
//       }
//       busy = true;
//       render();
//       clearTimeout(checkoutTimeout);
//       checkoutTimeout = setTimeout(function () {
//         if (busy) { busy = false; render(); toast('Request timed out. Please refresh and try again.'); }
//       }, 15000);

//       var itemsList = state.slots.map(function (s) {
//         return s.title + (s.size ? ' (' + s.size + ')' : '');
//       }).join(' | ');

//       var props = {
//         _bundle_size: String(state.qty),
//         _bundle_group: state.group,
//         _bundle_size_type: state.defaultSize,
//         _bundle_items: itemsList
//       };
//       props['Bundle'] = GROUP_LABELS[state.group] + ' × Pack of ' + state.qty;
//       state.slots.forEach(function (s, i) {
//         props['Bedsheet ' + (i + 1)] = s.title + (s.size ? ' (' + s.size + ')' : '');
//       });

//       var items = [{ id: hiddenId, quantity: 1, properties: props }];

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ items: items })
//       })
//         .then(function (res) {
//           return res.text().then(function (text) {
//             var data;
//             try { data = JSON.parse(text); } catch (e) { data = { raw: text }; }
//             if (!res.ok) {
//               var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status + ': ' + (data.raw || 'Unknown error'));
//               throw new Error(msg);
//             }
//             return data;
//           });
//         })
//         .then(function () {
//           clearTimeout(checkoutTimeout);
//           try { sessionStorage.setItem(DONE, '1'); } catch (e) {}
//           window.location.href = '/checkout';
//         })
//         .catch(function (err) {
//           clearTimeout(checkoutTimeout);
//           busy = false;
//           render();
//           toast(err.message || 'Something went wrong. Please try again.');
//         });
//     }

//     /* ---------- render ---------- */
//     function render() {
//       if (headerSelect) headerSelect.value = variantOf(state.defaultSize);

//       updateGroupBadge();

//       // Packs
//       packs.forEach(function (p) {
//         var on = p.qty === state.qty;
//         p.el.classList.toggle('is-active', on);
//         p.el.setAttribute('aria-pressed', on ? 'true' : 'false');
//         var table = DISPLAY_PRICES[state.defaultSize] || DISPLAY_PRICES.single_flat;
//         var display = table[p.qty] || 0;
//         var per = perSheetPrice();
//         var original = per * p.qty;
//         var saveAmt = Math.max(original - display, 0);
//         if (p.priceEl) p.priceEl.textContent = moneyShort(display);
//         if (p.eachEl) {
//           if (p.qty > 1 && display > 0) {
//             p.eachEl.textContent = moneyShort(Math.round(display / p.qty)) + ' each';
//             p.eachEl.hidden = false;
//           } else { p.eachEl.textContent = ''; p.eachEl.hidden = true; }
//         }
//         if (p.afterEl) {
//           if (saveAmt > 0) { p.afterEl.textContent = 'Save ' + moneyShort(saveAmt); p.afterEl.hidden = false; }
//           else { p.afterEl.hidden = true; }
//         }
//       });

//       // Fixed price / note
//       var display = displayPrice();
//       if (fixedAmountEl) fixedAmountEl.textContent = money(display);
//       if (fixedNoteEl) fixedNoteEl.textContent = GROUP_LABELS[state.group] + ' × Pack of ' + state.qty;

//       // Slots
//       var n = state.slots.length;
//       var left = state.qty - n;
//       var full = left <= 0;

//       var html = '';
//       for (var i = 0; i < state.qty; i++) {
//         if (i < n) {
//           var s = state.slots[i];
//           var label = s.title + (s.size ? ' (' + s.size + ')' : '');
//           html += '<div class="bb-slot is-filled" title="' + esc(label) + '">' +
//             (s.img ? '<img src="' + esc(s.img) + '" alt="' + esc(s.title) + '">' : '') +
//             (s.size ? '<span class="bb-slot-size">' + esc(s.size) + '</span>' : '') +
//             '<button type="button" class="bb-x" data-bb-remove="' + i + '" aria-label="Remove ' + esc(s.title) + '">&times;</button>' +
//             '</div>';
//         } else {
//           html += '<div class="bb-slot"><span>' + (i + 1) + '</span></div>';
//         }
//       }
//       if (slotsEl) slotsEl.innerHTML = html;

//       if (msgEl) msgEl.textContent = full ? 'Your bundle is ready!' : 'Add ' + left + ' more to complete your bundle.';
//       if (totalEl) totalEl.textContent = money(display);
//       if (progEl) progEl.style.width = Math.round(n / state.qty * 100) + '%';
//       if (pickedEl) pickedEl.textContent = n;
//       if (targetEl) targetEl.textContent = state.qty;
//       if (ctaMainEl) ctaMainEl.textContent = busy ? 'Please wait...' : (full ? 'Checkout' : 'Add ' + left + ' more');
//       if (ctaSubEl) ctaSubEl.textContent = moneyShort(display) + ' total';
//       if (ctaEl) ctaEl.disabled = !full || busy;
//       root.classList.toggle('is-full', full);

//       // Save text
//       if (saveTextEl) {
//         var orig = originalPrice();
//         var saveAmt = Math.max(orig - display, 0);
//         var savePct = orig > 0 ? ((saveAmt / orig) * 100) : 0;
//         var pctText = (Math.round(savePct * 10) / 10);
//         if (saveAmt > 0) {
//           saveTextEl.textContent = 'You save ' + moneyShort(saveAmt) + ' (' + pctText + '%)';
//           saveTextEl.hidden = false;
//         } else { saveTextEl.textContent = ''; saveTextEl.hidden = true; }
//       }

//       // Cards
//       var counts = {};
//       state.slots.forEach(function (s) { counts[s.pid] = (counts[s.pid] || 0) + 1; });
//       var fullCards = state.slots.length >= state.qty;

//       Array.prototype.forEach.call(cards(), function (card) {
//         var c = counts[card.getAttribute('data-pid')] || 0;
//         var add = card.querySelector('[data-bb-add]');
//         var step = card.querySelector('[data-bb-step]');
//         var num = card.querySelector('[data-bb-qtyn]');
//         var badge = card.querySelector('[data-bb-count]');

//         var hasAny = cardHasAnyInGroup(card, state.group);
//         card.hidden = !hasAny;
//         card.classList.toggle('is-picked', c > 0);

//         if (add) { add.hidden = c > 0; add.disabled = fullCards; }
//         if (step) {
//           step.hidden = c === 0;
//           var inc = step.querySelector('[data-bb-inc]');
//           if (inc) inc.disabled = fullCards;
//         }
//         if (num) num.textContent = c;
//         if (badge) { badge.hidden = c === 0; badge.textContent = '×' + c; }
//       });
//     }

//     /* ---------- load more + search ---------- */
//     function updateLoadUi() {
//       var loaded = cards().length;
//       var left = Math.max(totalItems - loaded, 0);
//       var more = nextPage > 0 && nextPage <= totalPages && left > 0;
//       if (loadWrap) loadWrap.hidden = !more;
//       if (loadBtn) {
//         loadBtn.disabled = loading;
//         loadBtn.textContent = loading ? 'Loading...' : 'Load more' + (left ? ' (' + left + ' more)' : '');
//       }
//     }
//     function loadMore() {
//       if (loading || failed || !grid || !nextPage || nextPage > totalPages) return Promise.resolve();
//       loading = true;
//       updateLoadUi();
//       var url = new URL(window.location.href);
//       url.searchParams.set('page', nextPage);
//       url.searchParams.set('view', 'pb-bundle');
//       return fetch(url.toString(), { credentials: 'same-origin' })
//         .then(function (res) { if (!res.ok) throw new Error('Could not load more products.'); return res.text(); })
//         .then(function (html) {
//           var doc = new DOMParser().parseFromString(html, 'text/html');
//           var found = doc.querySelectorAll('[data-bb-grid] > [data-bb-card]');
//           Array.prototype.forEach.call(found, function (c) { grid.appendChild(document.importNode(c, true)); });
//           nextPage += 1;
//           if (!found.length) nextPage = 0;
//         })
//         .catch(function () { failed = true; toast('Could not load more products. Please refresh.'); })
//         .then(function () {
//           loading = false;
//           updateLoadUi();
//           render();
//           applySearch();
//           initMediaScroll();   // ← new cards ke liye
//         });
//     }
//     function loadAll() {
//       return loadMore().then(function () {
//         if (!failed && nextPage > 0 && nextPage <= totalPages) return loadAll();
//       });
//     }
//     function applySearch() {
//       var any = false;
//       Array.prototype.forEach.call(cards(), function (card) {
//         if (card.hidden && !card.classList.contains('is-picked')) return;
//         var hit = !query || (card.getAttribute('data-search') || '').indexOf(query) > -1;
//         card.hidden = !hit;
//         if (hit) any = true;
//       });
//       if (emptyEl) emptyEl.hidden = any || !cards().length;
//     }

//     /* ---------- events ---------- */
//     root.addEventListener('click', function (e) {
//       // Priority 1: card size pill buttons
//       var pill = e.target.closest('[data-bb-card-size-btn]');
//       if (pill && root.contains(pill)) {
//         var pillCard = pill.closest('[data-bb-card]');
//         if (pillCard) {
//           var siblings = pillCard.querySelectorAll('[data-bb-card-size-btn]');
//           Array.prototype.forEach.call(siblings, function (btn) {
//             var on = btn === pill;
//             btn.classList.toggle('is-active', on);
//             btn.setAttribute('aria-pressed', on ? 'true' : 'false');
//           });
//           return;
//         }
//       }

//       // Priority 2: other actions
//       var t = e.target.closest('[data-bb-pack],[data-bb-add],[data-bb-inc],[data-bb-dec],[data-bb-remove],[data-bb-cta],[data-bb-loadmore]');
//       if (!t || !root.contains(t)) return;

//       if (t.hasAttribute('data-bb-pack')) { setPack(parseInt(t.getAttribute('data-qty'), 10)); return; }
//       if (t.hasAttribute('data-bb-remove')) { removeAt(parseInt(t.getAttribute('data-bb-remove'), 10)); return; }
//       if (t.hasAttribute('data-bb-cta')) { checkout(); return; }
//       if (t.hasAttribute('data-bb-loadmore')) { loadMore(); return; }

//       var card = t.closest('[data-bb-card]');
//       if (!card) return;
//       if (t.hasAttribute('data-bb-add') || t.hasAttribute('data-bb-inc')) addFromCard(card);
//       else if (t.hasAttribute('data-bb-dec')) removeLastOf(card.getAttribute('data-pid'));
//     });

//     // Change event (header select agar ho to)
//     root.addEventListener('change', function (e) {
//       var t = e.target;
//       if (!t) return;
//       if (t.hasAttribute && t.hasAttribute('data-bb-size-select')) {
//         setDefaultVariant(t.value);
//         return;
//       }
//     });

//     if (searchEl) {
//       searchEl.addEventListener('input', function () {
//         clearTimeout(searchTimer);
//         searchTimer = setTimeout(function () {
//           query = searchEl.value.trim().toLowerCase();
//           applySearch();
//           if (query && nextPage > 0 && nextPage <= totalPages) loadAll();
//         }, 200);
//       });
//     }

//     window.addEventListener('pageshow', function () {
//       busy = false;
//       clearTimeout(checkoutTimeout);
//       if (consumeDone()) state.slots = [];
//       render();
//     });

//     /* ---------- start ---------- */
//     if (!consumeDone()) load();
//     readUrlParams();
//     render();
//     updateUrl();
//     updateLoadUi();
//     initMediaScroll();
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
//   else init();
// })();




// 2
// /**
//  * Pack Bundle Builder - Whimsy Weaves Bedsheets
//  * Section: sections/bundle-builder.liquid
//  *
//  * HIDDEN PRODUCTS APPROACH:
//  *   - Checkout par SIRF hidden bundle product cart mein jayega
//  *   - Exact fixed price milega (Rs. 1,200 / 2,200 / 3,200 / 5,200 etc.)
//  *   - Actual bedsheets properties mein jayenge (checkout par visible + record ke liye)
//  *   - Koi discount code nahi chahiye
//  */
// (function () {
//   'use strict';

//   // ============================================================
//   // HIDDEN BUNDLE PRODUCTS (Shopify Admin se IDs)
//   // ============================================================
//   var HIDDEN_PRODUCTS = {
//     single_flat: {
//       1: 44067277504575,  // Single Pack 1 Bundle - Rs. 1,200
//       2: 44067278979135,  // Single Pack 2 Bundle - Rs. 2,200
//       3: 44067280584767,  // Single Pack 3 Bundle - Rs. 3,200
//       5: 44067280781375   // Single Pack 5 Bundle - Rs. 5,200
//     },
//     single_fitted: {
//       1: 44067277504575,
//       2: 44067278979135,
//       3: 44067280584767,
//       5: 44067280781375
//     },
//     king_flat: {
//       1: 44067282223167,  // King Pack 1 Bundle - Rs. 1,600
//       2: 44067379478591,  // King Pack 2 Bundle - Rs. 2,900
//       3: 44067283304511,  // King Pack 3 Bundle - Rs. 4,200
//       5: 44067286646847   // King Pack 5 Bundle - Rs. 6,800
//     },
//     king_fitted: {
//       1: 44067282223167,
//       2: 44067379478591,
//       3: 44067283304511,
//       5: 44067286646847
//     }
//   };

//   // ============================================================
//   // DISPLAY PRICES (Customer ko bundle page par dikhane ke liye)
//   // ============================================================
//   var DISPLAY_PRICES = {
//     single_flat:   { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
//     single_fitted: { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
//     king_flat:     { 1: 1600, 2: 2900, 3: 4200, 5: 6800 },
//     king_fitted:   { 1: 1600, 2: 2900, 3: 4200, 5: 6800 }
//   };

//   var SIZE_LABELS = {
//     single_flat:   'Single Flat',
//     single_fitted: 'Single Fitted',
//     king_flat:     'King Flat',
//     king_fitted:   'King Fitted'
//   };

//   // ============================================================

//   function init() {
//     var root = document.querySelector('[data-bb]');
//     if (!root || root.__bbReady) return;
//     root.__bbReady = true;

//     var handle = root.getAttribute('data-collection') || 'all';
//     var KEY = 'bb:' + handle;
//     var DONE = 'bb:done:' + handle;

//     var grid = root.querySelector('[data-bb-grid]');
//     var subEl = root.querySelector('[data-bb-sub]');
//     var slotsEl = root.querySelector('[data-bb-slots]');
//     var msgEl = root.querySelector('[data-bb-msg]');
//     var totalEl = root.querySelector('[data-bb-total]');
//     var ctaEl = root.querySelector('[data-bb-cta]');
//     var progEl = root.querySelector('[data-bb-progress]');
//     var toastEl = root.querySelector('[data-bb-toast]');
//     var loadWrap = root.querySelector('[data-bb-loadwrap]');
//     var loadBtn = root.querySelector('[data-bb-loadmore]');
//     var searchEl = root.querySelector('[data-bb-search]');
//     var emptyEl = root.querySelector('[data-bb-empty]');
//     var fixedAmountEl = root.querySelector('[data-bb-fixed-amount]');
//     var fixedNoteEl = root.querySelector('[data-bb-fixed-note]');
//     var sizeTypeBtns = root.querySelectorAll('[data-bb-size-type]');

//     var packs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-pack]')).map(function (el) {
//       return {
//         el: el,
//         qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
//         priceEl: el.querySelector('[data-bb-pack-price]'),
//         afterEl: el.querySelector('[data-bb-pack-after]')
//       };
//     });
//     if (!packs.length) return;
//     packs.sort(function (a, b) { return a.qty - b.qty; });

//     var state = { size: 'king_flat', qty: packs[0].qty, slots: [] };
//     // var state = { size: 'single_flat', qty: packs[0].qty, slots: [] };

//     var busy = false;
//     var query = '';
//     var loading = false;
//     var failed = false;
//     var nextPage = grid ? parseInt(grid.getAttribute('data-next-page'), 10) || 0 : 0;
//     var totalPages = grid ? parseInt(grid.getAttribute('data-pages'), 10) || 1 : 1;
//     var totalItems = grid ? parseInt(grid.getAttribute('data-total'), 10) || 0 : 0;
//     var toastTimer = null;
//     var searchTimer = null;
//     var checkoutTimeout = null;

//     /* ---------- helpers ---------- */
//     function money(amount) {
//       var n = Number(amount);
//       if (isNaN(n)) n = 0;
//       var parts = n.toFixed(2).split('.');
//       var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//       return 'Rs. ' + intPart + '.' + parts[1];
//     }

//     function esc(s) {
//       return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
//         return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
//       });
//     }

//     function packOf(qty) {
//       for (var i = 0; i < packs.length; i++) if (packs[i].qty === qty) return packs[i];
//       return null;
//     }

//     function currentPack() { return packOf(state.qty) || packs[0]; }

//     function displayPrice() {
//       var table = DISPLAY_PRICES[state.size] || DISPLAY_PRICES.single_flat;
//       return table[state.qty] || 0;
//     }

//     function hiddenProductId() {
//       var table = HIDDEN_PRODUCTS[state.size];
//       if (!table) return null;
//       return table[state.qty] || null;
//     }

//     function cards() { return root.querySelectorAll('[data-bb-card]'); }

//     function toast(text) {
//       if (!toastEl) return;
//       toastEl.textContent = text;
//       toastEl.classList.add('is-on');
//       clearTimeout(toastTimer);
//       toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
//     }

//     /* ---------- storage ---------- */
//     function save() {
//       try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
//     }

//     function load() {
//       try {
//         var raw = sessionStorage.getItem(KEY);
//         if (!raw) return;
//         var s = JSON.parse(raw);
//         if (s && packOf(s.qty) && Array.isArray(s.slots)) {
//           if (s.size && DISPLAY_PRICES[s.size]) state.size = s.size;
//           state.qty = s.qty;
//           state.slots = s.slots.slice(0, s.qty);
//         }
//       } catch (e) {}
//     }

//     function consumeDone() {
//       var was = false;
//       try {
//         was = sessionStorage.getItem(DONE) === '1';
//         if (was) {
//           sessionStorage.removeItem(DONE);
//           sessionStorage.removeItem(KEY);
//         }
//       } catch (e) {}
//       return was;
//     }

//     /* ---------- card data ---------- */
//     function cardData(card) {
//       if (card.__bb) return card.__bb;
//       var d = { title: '', vendor: '', img: '', variants: [] };
//       var j = card.querySelector('[data-bb-json]');
//       try { d = JSON.parse(j.textContent); } catch (e) {}
//       d.pid = card.getAttribute('data-pid');
//       card.__bb = d;
//       return d;
//     }

//     function findVariantBySize(card, sizeKey) {
//       var d = cardData(card);
//       for (var i = 0; i < d.variants.length; i++) {
//         var v = d.variants[i];
//         if (v.sizeKey === sizeKey && v.available) return v;
//       }
//       return null;
//     }

//     function cardHasSize(card, sizeKey) {
//       return !!findVariantBySize(card, sizeKey);
//     }

//     /* ---------- actions ---------- */
//     function addFromCard(card) {
//       if (state.slots.length >= state.qty) {
//         toast('Your pack is full. Remove an item or choose a bigger pack.');
//         return;
//       }
//       var d = cardData(card);
//       var v = findVariantBySize(card, state.size);
//       if (!v) { toast('This size is not available for this product.'); return; }
//       state.slots.push({
//         pid: d.pid,
//         vid: v.id,
//         title: d.title,
//         vendor: d.vendor,
//         img: d.img || '',
//         size: v.title || '',
//         sizeKey: v.sizeKey || 'single_flat'
//       });
//       save();
//       render();
//     }

//     function removeLastOf(pid) {
//       for (var i = state.slots.length - 1; i >= 0; i--) {
//         if (String(state.slots[i].pid) === String(pid)) { state.slots.splice(i, 1); break; }
//       }
//       save();
//       render();
//     }

//     function removeAt(idx) {
//       if (idx < 0 || idx >= state.slots.length) return;
//       state.slots.splice(idx, 1);
//       save();
//       render();
//     }

//     function setPack(qty) {
//       if (!packOf(qty)) return;
//       var trimmed = state.slots.length > qty;
//       state.qty = qty;
//       if (trimmed) state.slots = state.slots.slice(0, qty);
//       save();
//       render();
//       if (trimmed) toast('Extra items were removed from your pack.');
//     }

//     function setSize(sizeKey) {
//       if (!DISPLAY_PRICES[sizeKey]) return;
//       if (state.size === sizeKey) return;
//       state.slots = state.slots.filter(function (s) {
//         return s.sizeKey === sizeKey;
//       });
//       state.size = sizeKey;
//       save();
//       render();
//     }

//     /* ---------- CHECKOUT (Hidden Product) ---------- */
//     function checkout() {
//       if (busy) return;
//       if (state.slots.length !== state.qty) {
//         toast('Please complete your pack first.');
//         return;
//       }

//       var hiddenId = hiddenProductId();
//       if (!hiddenId) {
//         toast('This bundle is not available. Please try another pack.');
//         return;
//       }

//       busy = true;
//       render();

//       // TIMEOUT HANDLER — 15 seconds baad button reset
//       clearTimeout(checkoutTimeout);
//       checkoutTimeout = setTimeout(function () {
//         if (busy) {
//           busy = false;
//           render();
//           toast('Request timed out. Please refresh and try again.');
//         }
//       }, 15000);

//       // Actual bedsheets ki details properties mein
//       var itemsList = state.slots.map(function (s) {
//         return s.title + (s.size ? ' (' + s.size + ')' : '');
//       }).join(' | ');

//       // Hidden properties (record ke liye, checkout par nahi dikhengi)
//       var props = {
//         _bundle_size: String(state.qty),
//         _bundle_size_type: state.size,
//         _bundle_items: itemsList
//       };

//       // Visible properties (checkout, order aur packing slip mein dikhengi)
//       props['Bundle'] = SIZE_LABELS[state.size] + ' × Pack of ' + state.qty;
//       state.slots.forEach(function (s, i) {
//         props['Bedsheet ' + (i + 1)] = s.title + (s.size ? ' (' + s.size + ')' : '');
//       });

//       var items = [{
//         id: hiddenId,
//         quantity: 1,
//         properties: props
//       }];

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ items: items })
//       })
//         .then(function (res) {
//           return res.text().then(function (text) {
//             var data;
//             try { data = JSON.parse(text); } catch (e) { data = { raw: text }; }
//             if (!res.ok) {
//               var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status + ': ' + (data.raw || 'Unknown error'));
//               throw new Error(msg);
//             }
//             return data;
//           });
//         })
//         .then(function () {
//           clearTimeout(checkoutTimeout);
//           try { sessionStorage.setItem(DONE, '1'); } catch (e) {}
//           window.location.href = '/checkout';
//         })
//         .catch(function (err) {
//           clearTimeout(checkoutTimeout);
//           busy = false;
//           render();
//           toast(err.message || 'Something went wrong. Please try again.');
//         });
//     }

//     /* ---------- render ---------- */
//     function renderSizeTypes() {
//       Array.prototype.forEach.call(sizeTypeBtns, function (btn) {
//         var sizeKey = btn.getAttribute('data-size');
//         var on = sizeKey === state.size;
//         btn.classList.toggle('is-active', on);
//         btn.setAttribute('aria-pressed', on ? 'true' : 'false');
//       });
//     }

//     function renderPacks() {
//       packs.forEach(function (p) {
//         var on = p.qty === state.qty;
//         p.el.classList.toggle('is-active', on);
//         p.el.setAttribute('aria-pressed', on ? 'true' : 'false');

//         var table = DISPLAY_PRICES[state.size] || DISPLAY_PRICES.single_flat;
//         var display = table[p.qty] || 0;

//         if (p.priceEl) p.priceEl.textContent = money(display);
//         if (p.afterEl) p.afterEl.hidden = true;
//       });
//     }

//     function renderFixedPrice() {
//       var display = displayPrice();

//       if (fixedAmountEl) fixedAmountEl.textContent = money(display);
//       if (fixedNoteEl) {
//         fixedNoteEl.textContent = SIZE_LABELS[state.size] + ' × Pack of ' + state.qty;
//       }
//     }

//     function renderSub() {
//       if (!subEl) return;
//       subEl.textContent = 'Pick any ' + state.qty + ' ' + SIZE_LABELS[state.size] + ' bedsheet' + (state.qty > 1 ? 's' : '') + ' from Whimsy Weaves.';
//     }

//     function renderBar() {
//       var n = state.slots.length;
//       var left = state.qty - n;
//       var full = left <= 0;
//       var display = displayPrice();

//       var html = '';
//       for (var i = 0; i < state.qty; i++) {
//         if (i < n) {
//           var s = state.slots[i];
//           var label = s.title + (s.size ? ' (' + s.size + ')' : '');
//           html += '<div class="bb-slot is-filled" title="' + esc(label) + '">' +
//             (s.img ? '<img src="' + esc(s.img) + '" alt="' + esc(s.title) + '">' : '') +
//             (s.size ? '<span class="bb-slot-size">' + esc(s.size) + '</span>' : '') +
//             '<button type="button" class="bb-x" data-bb-remove="' + i + '" aria-label="Remove ' + esc(s.title) + '">&times;</button>' +
//             '</div>';
//         } else {
//           html += '<div class="bb-slot"><span>' + (i + 1) + '</span></div>';
//         }
//       }
//       if (slotsEl) slotsEl.innerHTML = html;

//       if (msgEl) {
//         msgEl.textContent = full
//           ? 'Your bundle is ready!'
//           : 'Add ' + left + ' more to complete your bundle.';
//       }

//       if (totalEl) totalEl.textContent = money(display);

//       if (progEl) progEl.style.width = Math.round(n / state.qty * 100) + '%';

//       if (ctaEl) {
//         ctaEl.disabled = !full || busy;
//         ctaEl.textContent = busy ? 'Please wait...' : (full ? 'Checkout' : 'Add ' + left + ' more');
//       }
//       root.classList.toggle('is-full', full);
//     }

//     function renderCards() {
//       var counts = {};
//       state.slots.forEach(function (s) { counts[s.pid] = (counts[s.pid] || 0) + 1; });
//       var full = state.slots.length >= state.qty;

//       Array.prototype.forEach.call(cards(), function (card) {
//         var c = counts[card.getAttribute('data-pid')] || 0;
//         var add = card.querySelector('[data-bb-add]');
//         var step = card.querySelector('[data-bb-step]');
//         var num = card.querySelector('[data-bb-qtyn]');
//         var badge = card.querySelector('[data-bb-count]');

//         var hasSize = cardHasSize(card, state.size);

//         card.hidden = !hasSize;
//         card.classList.toggle('is-picked', c > 0);

//         if (add) { add.hidden = c > 0; add.disabled = full; }
//         if (step) {
//           step.hidden = c === 0;
//           var inc = step.querySelector('[data-bb-inc]');
//           if (inc) inc.disabled = full;
//         }
//         if (num) num.textContent = c;
//         if (badge) { badge.hidden = c === 0; badge.textContent = '×' + c; }
//       });
//     }

//     function render() {
//       renderSizeTypes();
//       renderPacks();
//       renderFixedPrice();
//       renderSub();
//       renderBar();
//       renderCards();
//     }

//     /* ---------- load more + search ---------- */
//     function updateLoadUi() {
//       var loaded = cards().length;
//       var left = Math.max(totalItems - loaded, 0);
//       var more = nextPage > 0 && nextPage <= totalPages && left > 0;
//       if (loadWrap) loadWrap.hidden = !more;
//       if (loadBtn) {
//         loadBtn.disabled = loading;
//         loadBtn.textContent = loading ? 'Loading...' : 'Load more' + (left ? ' (' + left + ' more)' : '');
//       }
//     }

//     function loadMore() {
//       if (loading || failed || !grid || !nextPage || nextPage > totalPages) return Promise.resolve();
//       loading = true;
//       updateLoadUi();

//       var url = new URL(window.location.href);
//       url.searchParams.set('page', nextPage);
//       url.searchParams.set('view', 'pb-bundle');

//       return fetch(url.toString(), { credentials: 'same-origin' })
//         .then(function (res) {
//           if (!res.ok) throw new Error('Could not load more products.');
//           return res.text();
//         })
//         .then(function (html) {
//           var doc = new DOMParser().parseFromString(html, 'text/html');
//           var found = doc.querySelectorAll('[data-bb-grid] > [data-bb-card]');
//           Array.prototype.forEach.call(found, function (c) { grid.appendChild(document.importNode(c, true)); });
//           nextPage += 1;
//           if (!found.length) nextPage = 0;
//         })
//         .catch(function () {
//           failed = true;
//           toast('Could not load more products. Please refresh.');
//         })
//         .then(function () {
//           loading = false;
//           updateLoadUi();
//           renderCards();
//           applySearch();
//         });
//     }

//     function loadAll() {
//       return loadMore().then(function () {
//         if (!failed && nextPage > 0 && nextPage <= totalPages) return loadAll();
//       });
//     }

//     function applySearch() {
//       var any = false;
//       Array.prototype.forEach.call(cards(), function (card) {
//         if (card.hidden && !card.classList.contains('is-picked')) return;
//         var hit = !query || (card.getAttribute('data-search') || '').indexOf(query) > -1;
//         card.hidden = !hit;
//         if (hit) any = true;
//       });
//       if (emptyEl) emptyEl.hidden = any || !cards().length;
//     }

//     /* ---------- events ---------- */
//     root.addEventListener('click', function (e) {
//       var t = e.target.closest('[data-bb-size-type],[data-bb-pack],[data-bb-add],[data-bb-inc],[data-bb-dec],[data-bb-remove],[data-bb-cta],[data-bb-loadmore]');
//       if (!t || !root.contains(t)) return;

//       if (t.hasAttribute('data-bb-size-type')) { setSize(t.getAttribute('data-size')); return; }
//       if (t.hasAttribute('data-bb-pack')) { setPack(parseInt(t.getAttribute('data-qty'), 10)); return; }
//       if (t.hasAttribute('data-bb-remove')) { removeAt(parseInt(t.getAttribute('data-bb-remove'), 10)); return; }
//       if (t.hasAttribute('data-bb-cta')) { checkout(); return; }
//       if (t.hasAttribute('data-bb-loadmore')) { loadMore(); return; }

//       var card = t.closest('[data-bb-card]');
//       if (!card) return;
//       if (t.hasAttribute('data-bb-add') || t.hasAttribute('data-bb-inc')) addFromCard(card);
//       else if (t.hasAttribute('data-bb-dec')) removeLastOf(card.getAttribute('data-pid'));
//     });

//     if (searchEl) {
//       searchEl.addEventListener('input', function () {
//         clearTimeout(searchTimer);
//         searchTimer = setTimeout(function () {
//           query = searchEl.value.trim().toLowerCase();
//           applySearch();
//           if (query && nextPage > 0 && nextPage <= totalPages) loadAll();
//         }, 200);
//       });
//     }

//     window.addEventListener('pageshow', function (e) {
//       busy = false;
//       clearTimeout(checkoutTimeout);
//       if (consumeDone()) {
//         state.slots = [];
//       }
//       render();
//     });

//     /* ---------- start ---------- */
//     if (!consumeDone()) load();
//     render();
//     updateLoadUi();
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
//   else init();
// })();




// 1
// /**
//  * Pack Bundle Builder - Whimsy Weaves Bedsheets
//  * Section: sections/bundle-builder.liquid
//  *
//  * HIDDEN PRODUCTS APPROACH:
//  *   - Checkout par SIRF hidden bundle product cart mein jayega
//  *   - Exact fixed price milega (Rs. 1,200 / 2,200 / 3,200 / 5,200 etc.)
//  *   - Actual bedsheets properties mein jayenge (record ke liye)
//  *   - Koi discount code nahi chahiye
//  */
// (function () {
//   'use strict';

//   // ============================================================
//   // HIDDEN BUNDLE PRODUCTS (Shopify Admin se IDs)
//   // ============================================================
// var HIDDEN_PRODUCTS = {
//   single_flat: {
//     1: 44067277504575,  // Single Pack 1 Bundle - Rs. 1,200
//     2: 44067278979135,  // Single Pack 2 Bundle - Rs. 2,200
//     3: 44067280584767,  // Single Pack 3 Bundle - Rs. 3,200
//     5: 44067280781375   // Single Pack 5 Bundle - Rs. 5,200
//   },
//   single_fitted: {
//     1: 44067277504575,
//     2: 44067278979135,
//     3: 44067280584767,
//     5: 44067280781375
//   },
//   king_flat: {
//     1: 44067282223167,  // King Pack 1 Bundle - Rs. 1,600
//     2: 44067379478591,  // King Pack 2 Bundle - Rs. 2,900
//     3: 44067283304511,  // King Pack 3 Bundle - Rs. 4,200
//     5: 44067286646847   // King Pack 5 Bundle - Rs. 6,800
//   },
//   king_fitted: {
//     1: 44067282223167,
//     2: 44067379478591,
//     3: 44067283304511,
//     5: 44067286646847
//   }
// };

//   // ============================================================
//   // DISPLAY PRICES (Customer ko bundle page par dikhane ke liye)
//   // ============================================================
//   var DISPLAY_PRICES = {
//     single_flat:   { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
//     single_fitted: { 1: 1200, 2: 2200, 3: 3200, 5: 5200 },
//     king_flat:     { 1: 1600, 2: 2900, 3: 4200, 5: 6800 },
//     king_fitted:   { 1: 1600, 2: 2900, 3: 4200, 5: 6800 }
//   };

//   var SIZE_LABELS = {
//     single_flat:   'Single Flat',
//     single_fitted: 'Single Fitted',
//     king_flat:     'King Flat',
//     king_fitted:   'King Fitted'
//   };

//   // ============================================================

//   function init() {
//     var root = document.querySelector('[data-bb]');
//     if (!root || root.__bbReady) return;
//     root.__bbReady = true;

//     var handle = root.getAttribute('data-collection') || 'all';
//     var KEY = 'bb:' + handle;
//     var DONE = 'bb:done:' + handle;

//     var grid = root.querySelector('[data-bb-grid]');
//     var subEl = root.querySelector('[data-bb-sub]');
//     var slotsEl = root.querySelector('[data-bb-slots]');
//     var msgEl = root.querySelector('[data-bb-msg]');
//     var totalEl = root.querySelector('[data-bb-total]');
//     var ctaEl = root.querySelector('[data-bb-cta]');
//     var progEl = root.querySelector('[data-bb-progress]');
//     var toastEl = root.querySelector('[data-bb-toast]');
//     var loadWrap = root.querySelector('[data-bb-loadwrap]');
//     var loadBtn = root.querySelector('[data-bb-loadmore]');
//     var searchEl = root.querySelector('[data-bb-search]');
//     var emptyEl = root.querySelector('[data-bb-empty]');
//     var fixedAmountEl = root.querySelector('[data-bb-fixed-amount]');
//     var fixedNoteEl = root.querySelector('[data-bb-fixed-note]');
//     var sizeTypeBtns = root.querySelectorAll('[data-bb-size-type]');

//     var packs = Array.prototype.slice.call(root.querySelectorAll('[data-bb-pack]')).map(function (el) {
//       return {
//         el: el,
//         qty: parseInt(el.getAttribute('data-qty'), 10) || 1,
//         priceEl: el.querySelector('[data-bb-pack-price]'),
//         afterEl: el.querySelector('[data-bb-pack-after]')
//       };
//     });
//     if (!packs.length) return;
//     packs.sort(function (a, b) { return a.qty - b.qty; });

//     var state = { size: 'king_flat', qty: packs[0].qty, slots: [] };
//     // var state = { size: 'single_flat', qty: packs[0].qty, slots: [] };

//     var busy = false;
//     var query = '';
//     var loading = false;
//     var failed = false;
//     var nextPage = grid ? parseInt(grid.getAttribute('data-next-page'), 10) || 0 : 0;
//     var totalPages = grid ? parseInt(grid.getAttribute('data-pages'), 10) || 1 : 1;
//     var totalItems = grid ? parseInt(grid.getAttribute('data-total'), 10) || 0 : 0;
//     var toastTimer = null;
//     var searchTimer = null;
//     var checkoutTimeout = null;

//     /* ---------- helpers ---------- */
//     function money(amount) {
//       var n = Number(amount);
//       if (isNaN(n)) n = 0;
//       var parts = n.toFixed(2).split('.');
//       var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
//       return 'Rs. ' + intPart + '.' + parts[1];
//     }

//     function esc(s) {
//       return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
//         return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
//       });
//     }

//     function packOf(qty) {
//       for (var i = 0; i < packs.length; i++) if (packs[i].qty === qty) return packs[i];
//       return null;
//     }

//     function currentPack() { return packOf(state.qty) || packs[0]; }

//     function displayPrice() {
//       var table = DISPLAY_PRICES[state.size] || DISPLAY_PRICES.single_flat;
//       return table[state.qty] || 0;
//     }

//     function hiddenProductId() {
//       var table = HIDDEN_PRODUCTS[state.size];
//       if (!table) return null;
//       return table[state.qty] || null;
//     }

//     function cards() { return root.querySelectorAll('[data-bb-card]'); }

//     function toast(text) {
//       if (!toastEl) return;
//       toastEl.textContent = text;
//       toastEl.classList.add('is-on');
//       clearTimeout(toastTimer);
//       toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3500);
//     }

//     /* ---------- storage ---------- */
//     function save() {
//       try { sessionStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
//     }

//     function load() {
//       try {
//         var raw = sessionStorage.getItem(KEY);
//         if (!raw) return;
//         var s = JSON.parse(raw);
//         if (s && packOf(s.qty) && Array.isArray(s.slots)) {
//           if (s.size && DISPLAY_PRICES[s.size]) state.size = s.size;
//           state.qty = s.qty;
//           state.slots = s.slots.slice(0, s.qty);
//         }
//       } catch (e) {}
//     }

//     function consumeDone() {
//       var was = false;
//       try {
//         was = sessionStorage.getItem(DONE) === '1';
//         if (was) {
//           sessionStorage.removeItem(DONE);
//           sessionStorage.removeItem(KEY);
//         }
//       } catch (e) {}
//       return was;
//     }

//     /* ---------- card data ---------- */
//     function cardData(card) {
//       if (card.__bb) return card.__bb;
//       var d = { title: '', vendor: '', img: '', variants: [] };
//       var j = card.querySelector('[data-bb-json]');
//       try { d = JSON.parse(j.textContent); } catch (e) {}
//       d.pid = card.getAttribute('data-pid');
//       card.__bb = d;
//       return d;
//     }

//     function findVariantBySize(card, sizeKey) {
//       var d = cardData(card);
//       for (var i = 0; i < d.variants.length; i++) {
//         var v = d.variants[i];
//         if (v.sizeKey === sizeKey && v.available) return v;
//       }
//       return null;
//     }

//     function cardHasSize(card, sizeKey) {
//       return !!findVariantBySize(card, sizeKey);
//     }

//     /* ---------- actions ---------- */
//     function addFromCard(card) {
//       if (state.slots.length >= state.qty) {
//         toast('Your pack is full. Remove an item or choose a bigger pack.');
//         return;
//       }
//       var d = cardData(card);
//       var v = findVariantBySize(card, state.size);
//       if (!v) { toast('This size is not available for this product.'); return; }
//       state.slots.push({
//         pid: d.pid,
//         vid: v.id,
//         title: d.title,
//         vendor: d.vendor,
//         img: d.img || '',
//         size: v.title || '',
//         sizeKey: v.sizeKey || 'single_flat'
//       });
//       save();
//       render();
//     }

//     function removeLastOf(pid) {
//       for (var i = state.slots.length - 1; i >= 0; i--) {
//         if (String(state.slots[i].pid) === String(pid)) { state.slots.splice(i, 1); break; }
//       }
//       save();
//       render();
//     }

//     function removeAt(idx) {
//       if (idx < 0 || idx >= state.slots.length) return;
//       state.slots.splice(idx, 1);
//       save();
//       render();
//     }

//     function setPack(qty) {
//       if (!packOf(qty)) return;
//       var trimmed = state.slots.length > qty;
//       state.qty = qty;
//       if (trimmed) state.slots = state.slots.slice(0, qty);
//       save();
//       render();
//       if (trimmed) toast('Extra items were removed from your pack.');
//     }

//     function setSize(sizeKey) {
//       if (!DISPLAY_PRICES[sizeKey]) return;
//       if (state.size === sizeKey) return;
//       state.slots = state.slots.filter(function (s) {
//         return s.sizeKey === sizeKey;
//       });
//       state.size = sizeKey;
//       save();
//       render();
//     }

//     /* ---------- CHECKOUT (Hidden Product) ---------- */
//     function checkout() {
//       if (busy) return;
//       if (state.slots.length !== state.qty) {
//         toast('Please complete your pack first.');
//         return;
//       }

//       var hiddenId = hiddenProductId();
//       if (!hiddenId) {
//         toast('This bundle is not available. Please try another pack.');
//         return;
//       }

//       busy = true;
//       render();

//       // ⚠️ TIMEOUT HANDLER — 15 seconds baad button reset
//       clearTimeout(checkoutTimeout);
//       checkoutTimeout = setTimeout(function () {
//         if (busy) {
//           busy = false;
//           render();
//           toast('Request timed out. Please refresh and try again.');
//         }
//       }, 15000);

//       // Actual bedsheets ki details properties mein
//       var itemsList = state.slots.map(function (s) {
//         return s.title + (s.size ? ' (' + s.size + ')' : '');
//       }).join(' | ');

//       var items = [{
//         id: hiddenId,
//         quantity: 1,
//         properties: {
//           _bundle_size: String(state.qty),
//           _bundle_size_type: state.size,
//           _bundle_items: itemsList
//         }
//       }];

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ items: items })
//       })
//         .then(function (res) {
//           return res.text().then(function (text) {
//             var data;
//             try { data = JSON.parse(text); } catch (e) { data = { raw: text }; }
//             if (!res.ok) {
//               var msg = (data && (data.description || data.message)) || ('HTTP ' + res.status + ': ' + (data.raw || 'Unknown error'));
//               throw new Error(msg);
//             }
//             return data;
//           });
//         })
//         .then(function () {
//           clearTimeout(checkoutTimeout);
//           try { sessionStorage.setItem(DONE, '1'); } catch (e) {}
//           window.location.href = '/checkout';
//         })
//         .catch(function (err) {
//           clearTimeout(checkoutTimeout);
//           busy = false;
//           render();
//           toast(err.message || 'Something went wrong. Please try again.');
//         });
//     }

//     /* ---------- render ---------- */
//     function renderSizeTypes() {
//       Array.prototype.forEach.call(sizeTypeBtns, function (btn) {
//         var sizeKey = btn.getAttribute('data-size');
//         var on = sizeKey === state.size;
//         btn.classList.toggle('is-active', on);
//         btn.setAttribute('aria-pressed', on ? 'true' : 'false');
//       });
//     }

//     function renderPacks() {
//       packs.forEach(function (p) {
//         var on = p.qty === state.qty;
//         p.el.classList.toggle('is-active', on);
//         p.el.setAttribute('aria-pressed', on ? 'true' : 'false');

//         var table = DISPLAY_PRICES[state.size] || DISPLAY_PRICES.single_flat;
//         var display = table[p.qty] || 0;

//         if (p.priceEl) p.priceEl.textContent = money(display);
//         if (p.afterEl) p.afterEl.hidden = true;
//       });
//     }

//     function renderFixedPrice() {
//       var display = displayPrice();

//       if (fixedAmountEl) fixedAmountEl.textContent = money(display);
//       if (fixedNoteEl) {
//         fixedNoteEl.textContent = SIZE_LABELS[state.size] + ' × Pack of ' + state.qty;
//       }
//     }

//     function renderSub() {
//       if (!subEl) return;
//       subEl.textContent = 'Pick any ' + state.qty + ' ' + SIZE_LABELS[state.size] + ' bedsheet' + (state.qty > 1 ? 's' : '') + ' from Whimsy Weaves.';
//     }

//     function renderBar() {
//       var n = state.slots.length;
//       var left = state.qty - n;
//       var full = left <= 0;
//       var display = displayPrice();

//       var html = '';
//       for (var i = 0; i < state.qty; i++) {
//         if (i < n) {
//           var s = state.slots[i];
//           var label = s.title + (s.size ? ' (' + s.size + ')' : '');
//           html += '<div class="bb-slot is-filled" title="' + esc(label) + '">' +
//             (s.img ? '<img src="' + esc(s.img) + '" alt="' + esc(s.title) + '">' : '') +
//             (s.size ? '<span class="bb-slot-size">' + esc(s.size) + '</span>' : '') +
//             '<button type="button" class="bb-x" data-bb-remove="' + i + '" aria-label="Remove ' + esc(s.title) + '">&times;</button>' +
//             '</div>';
//         } else {
//           html += '<div class="bb-slot"><span>' + (i + 1) + '</span></div>';
//         }
//       }
//       if (slotsEl) slotsEl.innerHTML = html;

//       if (msgEl) {
//         msgEl.textContent = full
//           ? 'Your bundle is ready!'
//           : 'Add ' + left + ' more to complete your bundle.';
//       }

//       if (totalEl) totalEl.textContent = money(display);

//       if (progEl) progEl.style.width = Math.round(n / state.qty * 100) + '%';

//       if (ctaEl) {
//         ctaEl.disabled = !full || busy;
//         ctaEl.textContent = busy ? 'Please wait...' : (full ? 'Checkout' : 'Add ' + left + ' more');
//       }
//       root.classList.toggle('is-full', full);
//     }

//     function renderCards() {
//       var counts = {};
//       state.slots.forEach(function (s) { counts[s.pid] = (counts[s.pid] || 0) + 1; });
//       var full = state.slots.length >= state.qty;

//       Array.prototype.forEach.call(cards(), function (card) {
//         var c = counts[card.getAttribute('data-pid')] || 0;
//         var add = card.querySelector('[data-bb-add]');
//         var step = card.querySelector('[data-bb-step]');
//         var num = card.querySelector('[data-bb-qtyn]');
//         var badge = card.querySelector('[data-bb-count]');

//         var hasSize = cardHasSize(card, state.size);

//         card.hidden = !hasSize;
//         card.classList.toggle('is-picked', c > 0);

//         if (add) { add.hidden = c > 0; add.disabled = full; }
//         if (step) {
//           step.hidden = c === 0;
//           var inc = step.querySelector('[data-bb-inc]');
//           if (inc) inc.disabled = full;
//         }
//         if (num) num.textContent = c;
//         if (badge) { badge.hidden = c === 0; badge.textContent = '×' + c; }
//       });
//     }

//     function render() {
//       renderSizeTypes();
//       renderPacks();
//       renderFixedPrice();
//       renderSub();
//       renderBar();
//       renderCards();
//     }

//     /* ---------- load more + search ---------- */
//     function updateLoadUi() {
//       var loaded = cards().length;
//       var left = Math.max(totalItems - loaded, 0);
//       var more = nextPage > 0 && nextPage <= totalPages && left > 0;
//       if (loadWrap) loadWrap.hidden = !more;
//       if (loadBtn) {
//         loadBtn.disabled = loading;
//         loadBtn.textContent = loading ? 'Loading...' : 'Load more' + (left ? ' (' + left + ' more)' : '');
//       }
//     }

//     function loadMore() {
//       if (loading || failed || !grid || !nextPage || nextPage > totalPages) return Promise.resolve();
//       loading = true;
//       updateLoadUi();

//       var url = new URL(window.location.href);
//       url.searchParams.set('page', nextPage);
//       url.searchParams.set('view', 'pb-bundle');

//       return fetch(url.toString(), { credentials: 'same-origin' })
//         .then(function (res) {
//           if (!res.ok) throw new Error('Could not load more products.');
//           return res.text();
//         })
//         .then(function (html) {
//           var doc = new DOMParser().parseFromString(html, 'text/html');
//           var found = doc.querySelectorAll('[data-bb-grid] > [data-bb-card]');
//           Array.prototype.forEach.call(found, function (c) { grid.appendChild(document.importNode(c, true)); });
//           nextPage += 1;
//           if (!found.length) nextPage = 0;
//         })
//         .catch(function () {
//           failed = true;
//           toast('Could not load more products. Please refresh.');
//         })
//         .then(function () {
//           loading = false;
//           updateLoadUi();
//           renderCards();
//           applySearch();
//         });
//     }

//     function loadAll() {
//       return loadMore().then(function () {
//         if (!failed && nextPage > 0 && nextPage <= totalPages) return loadAll();
//       });
//     }

//     function applySearch() {
//       var any = false;
//       Array.prototype.forEach.call(cards(), function (card) {
//         if (card.hidden && !card.classList.contains('is-picked')) return;
//         var hit = !query || (card.getAttribute('data-search') || '').indexOf(query) > -1;
//         card.hidden = !hit;
//         if (hit) any = true;
//       });
//       if (emptyEl) emptyEl.hidden = any || !cards().length;
//     }

//     /* ---------- events ---------- */
//     root.addEventListener('click', function (e) {
//       var t = e.target.closest('[data-bb-size-type],[data-bb-pack],[data-bb-add],[data-bb-inc],[data-bb-dec],[data-bb-remove],[data-bb-cta],[data-bb-loadmore]');
//       if (!t || !root.contains(t)) return;

//       if (t.hasAttribute('data-bb-size-type')) { setSize(t.getAttribute('data-size')); return; }
//       if (t.hasAttribute('data-bb-pack')) { setPack(parseInt(t.getAttribute('data-qty'), 10)); return; }
//       if (t.hasAttribute('data-bb-remove')) { removeAt(parseInt(t.getAttribute('data-bb-remove'), 10)); return; }
//       if (t.hasAttribute('data-bb-cta')) { checkout(); return; }
//       if (t.hasAttribute('data-bb-loadmore')) { loadMore(); return; }

//       var card = t.closest('[data-bb-card]');
//       if (!card) return;
//       if (t.hasAttribute('data-bb-add') || t.hasAttribute('data-bb-inc')) addFromCard(card);
//       else if (t.hasAttribute('data-bb-dec')) removeLastOf(card.getAttribute('data-pid'));
//     });

//     if (searchEl) {
//       searchEl.addEventListener('input', function () {
//         clearTimeout(searchTimer);
//         searchTimer = setTimeout(function () {
//           query = searchEl.value.trim().toLowerCase();
//           applySearch();
//           if (query && nextPage > 0 && nextPage <= totalPages) loadAll();
//         }, 200);
//       });
//     }

//     window.addEventListener('pageshow', function (e) {
//       busy = false;
//       clearTimeout(checkoutTimeout);
//       if (consumeDone()) {
//         state.slots = [];
//       }
//       render();
//     });

//     /* ---------- start ---------- */
//     if (!consumeDone()) load();
//     render();
//     updateLoadUi();
//   }

//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
//   else init();
// })();